// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Enums
import { EngagementReportSectionType } from 'engagementReport/enums/propTypes';

// Components
import EngagementReportQuestion from 'engagementReport/components/base/EngagementReportQuestion';

const EngagementReportSection = ({ section, defaultLanguage }) => {
  return (
    <div className="engagement-report-section">
      {section.questions.map((question) => (
        <EngagementReportQuestion
          question={question}
          key={question.id}
          defaultLanguage={defaultLanguage}
        /> // eslint-disable-line react/no-array-index-key
      ))}
    </div>
  );
};

EngagementReportSection.propTypes = {
  section: EngagementReportSectionType.isRequired,
  defaultLanguage: PropTypes.string.isRequired,
};

export default EngagementReportSection;
